module.exports = __webpack_public_path__ + "static/social_discord-e983a28d0f2f02a5de872e89884f3faf.png";